import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@paypalcorp/pp-react-buttons';
import { Field } from 'redux-form';
import getContent from 'pp-react-l10n';
import { renderSwitchComponent } from '../switchPanels/SwitchPanel';
import ImageModal from './ImageModal';
import _isEmpty from 'lodash/isEmpty';
import { EditIcon } from '@paypalcorp/pp-react-icons';
import { ContextualAlert } from '@paypalcorp/pp-react-contextual-alert';
import { FPTI_SPEC } from '../../utilsV3/fptiConstants';
import { trackEventWithData } from '../../utilsV3/analytics';

const getImageBannerContent = getContent('locals')('buttonsV3/imageBanner');
const title = getImageBannerContent('switchTitle');
const button = getImageBannerContent('uploadButton');
const editButton = getImageBannerContent('editButton');

const BannerImage = ({
  isChecked,
  uploadImage,
  bannerImageUrl,
  bannerClientError,
  dispatch,
  isMobile,
  showBadge,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleUploadNewImage = () => {
    setIsOpen(true);
    trackEventWithData(
      FPTI_SPEC.EXPERIENCE_SETUP_PAGE_UPLOAD_BACKGOURND_IMG_CL
    );
  };

  const bannerImageContainer = () => {
    if (_isEmpty(bannerImageUrl)) {
      return (
        <>
          <Button
            type="Button"
            className="upload-button"
            onClick={handleUploadNewImage}
            secondary
          >
            {button}
          </Button>
          {bannerClientError && (
            <ContextualAlert type="error">{bannerClientError}</ContextualAlert>
          )}
        </>
      );
    }
    return (
      <div className="banner-img-container">
        <img className="banner-img" src={bannerImageUrl} />
        <Button
          className="button-link"
          type="button"
          onClick={handleUploadNewImage}
          iconComponent={EditIcon}
          tertiary
        >
          {editButton}
        </Button>
      </div>
    );
  };

  return (
    <div className="banner-switch-container">
      <Field
        id="getBannerImage"
        name="noBannerImage"
        label="getBannerImage"
        title={title}
        component={renderSwitchComponent}
        isChecked={isChecked}
        reversed={true}
        showBadge={showBadge}
      />

      {isChecked && bannerImageContainer()}

      <ImageModal
        getContent={getImageBannerContent}
        isOpen={isOpen}
        handleCloseModal={() => setIsOpen(false)}
        uploadImage={uploadImage}
        bannerImageUrl={bannerImageUrl}
        dispatch={dispatch}
        isMobile={isMobile}
      />
    </div>
  );
};

BannerImage.propTypes = {
  isChecked: PropTypes.bool,
  uploadImage: PropTypes.func,
  bannerImageUrl: PropTypes.string,
  bannerClientError: PropTypes.string,
  dispatch: PropTypes.func,
  isMobile: PropTypes.bool,
  showBadge: PropTypes.bool,
};

export default BannerImage;
